<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-18 14:25:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-30 11:01:18
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/shipmentData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="shipment-data">
		<div class="shipment-data-form">
			<div class="label fz-12 mt-6">带货数据</div>
			<div class="content flex flex-wrap">
				<div class="form-item mr-32">
					<div class="form-label fz-12 mr-4">商家体验分 ≥ </div>
					<div class="form-content">
						<el-input
							@keyup.enter.native="handleSuccess('enter')"
							placeholder="请输入"
							type="number"
							style="width: 100px"
							v-model="form.shopScore"
							@blur="handleSuccess('blur','shopScore')"
						></el-input>
					</div>
				</div>
				<div class="form-item mr-32">
					<div class="form-label fz-12 mr-4">佣金机制</div> 
					<div class="form-content">
						<el-select :popper-append-to-body="false" popper-class="dropdown" style="width: 100px" v-model="form.commissionType" @change="onSelectChange">
							<el-option class="fz-12" v-for="item in options" :label="item.name" :value="item.value" :key="item.value">{{ item.name }}</el-option>
						</el-select>
					</div>
				</div>
				<template v-if="[unlimitedValue, deadCommission].includes(form.commissionType)">
					<div class="form-item mr-32">
						<div class="form-label fz-12 mr-4">达人佣金率 ≥ </div>
						<div class="form-content">
							<el-input
								@keyup.enter.native="handleSuccess('enter')"
								placeholder="请输入"
								type="number"
								style="width: 100px"
								v-model="form.talentCommission"
								@blur="handleSuccess('blur','talentCommission')"
							></el-input>
						</div>
					</div>
					<div class="form-item mr-32">
						<div class="form-label fz-12 mr-4">服务费率 ≥ </div>
						<div class="form-content">
							<el-input
								@keyup.enter.native="handleSuccess('enter')"
								placeholder="请输入"
								type="number"
								style="width: 100px"
								v-model="form.serviceFeeRate"
								@blur="handleSuccess('blur','serviceFeeRate')"
							></el-input>
						</div>
					</div>
				</template>
				<div class="form-item mr-32" v-if="[unlimitedValue, agilityCommission].includes(form.commissionType)">
					<div class="form-label fz-12 mr-4">灵活总佣 ≥ </div>
					<div class="form-content">
						<el-input
							@keyup.enter.native="handleSuccess('enter')"
							placeholder="请输入"
							type="number"
							style="width: 100px"
							v-model="form.commissionRate"
							@blur="handleSuccess('blur','commissionRate')"
						></el-input>
					</div>
				</div>
				<div class="form-item">
					<div class="form-label"></div>
					<div class="form-content">
						<el-checkbox class="audit-checkbox" :true-label="'1'" :false-label="''" @change="handleSuccess('enter')" v-model="form.auditStatus"
							>人工审核
							<el-tooltip class="item" effect="dark" placement="top" content="向商品来源发起推广审核，审核通过后自动报名并通过指定的招商活动计划">
								<el-icon class="el-icon-question yx-color-info"></el-icon>
							</el-tooltip>
						</el-checkbox>
					</div>
				</div>
				<div class="form-item" :class="[[agilityCommission, deadCommission].includes(form.commissionType) ? 'ml-32' : '',[unlimitedValue].includes(form.commissionType) ? 'mt-12' : '' ]">
					<div class="form-label fz-12 mr-4">商品来源</div>
					<div class="form-content">
						<el-select :popper-append-to-body="false" popper-class="dropdown" style="width: 100px" v-model="form.appType" @change="handleSuccess()">
							<el-option class="fz-12" v-for="item in goodSource" :label="item.name" :value="item.value" :key="item.value">{{ item.name }}</el-option>
						</el-select>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			form: {
				shopScore: '', //体验分
				commissionType: 0, // 佣金机制
				talentCommission: '', //达人佣金率
				serviceFeeRate: '', // 服务费率
				commissionRate: '', // 灵活总佣
				auditStatus: 0,
			},
			options: newDataMap.SHOP_MANAGE.COMMISSION_MCHANISM_OPTIONS,
			unlimitedValue: newDataMap.SHOP_MANAGE.UNLIMITED_COMMISSION.value, // 不限
			agilityCommission: newDataMap.SHOP_MANAGE.AGILITY_COMMISSION.value, // 灵活总佣
			deadCommission: newDataMap.SHOP_MANAGE.DEAD_COMMISSION.value, //固定佣金
			goodSource: newDataMap.SHOP_MANAGE.GOOD_SOURCE
		};
	},
	props:{
		searchParams:{
			type: Object,
			default:()=>{
				return {}
            }
		}
	},
	methods: {
		onSelectChange() {
			this.onEmpty();
		},
		handleSuccess(model,type) {
			if(model === 'blur' && this.form[type] === this.searchParams[type]){
				return
			}
			this.$emit('change', this.form);
		},
		onEmpty() {
			this.form.serviceFeeRate = '';
			this.form.talentCommission = '';
			this.form.commissionRate = '';
			this.handleSuccess();
		},
		onClear(key) {
			if (key === 'commissionType') {
				this.form.commissionType = 0;
				this.onEmpty();
				return;
			}
			this.form[key] = '';
			this.handleSuccess();
		},
	},
};
</script>
<style lang="less" scoped>
.shipment-data-form {
	display: flex;
	.label {
		margin-right: 32px;
		min-width: 48px;
		color: @color-gy7;
	}
	.content {
		flex: 1;
	}
	.form-item {
		display: flex;
		align-items: center;
		.form-label {
			color: @color-gy8;
		}
	}
	/deep/ input::-webkit-outer-spin-button,
	/deep/ input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}
	/deep/ input[type='number'] {
		-moz-appearance: textfield !important;
	}
	/deep/ .el-input__inner {
		font-size: 12px;
		height: 28px;
		line-height: 28px;
	}
	/deep/ .audit-checkbox {
		.el-checkbox__label {
			font-size: 12px;
			color: @color-gy8;
			font-weight: 400;
		}
	}
}
/deep/ .dropdown {
	border: 1px solid #f5f5f5;
}
.form-content{
	/deep/ .el-select .el-input--small .el-input__icon{
		line-height:  28px !important;
	}
}
.audit-checkbox{
	/deep/ .el-checkbox__inner{
		margin-top: 2px;
	}
}
</style>
